import { Component, inject } from '@angular/core';
import { LinkComponent } from '@components/link/link.component';
import { FeatureFlagEnum } from '@models/enums/feature-flag.enum';
import { CmsService } from '@services/cms/cms.service';
import { FeatureFlagService } from '@services/feature-flag/feature-flag.service';
import { ContactService } from '@services/contact/contact.service';
import { PhoneHrefPipe } from '@pipes/phone-href/phone-href.pipe';
import { PhoneMaskPipe } from '@pipes/phone-mask/phone-mask.pipe';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [LinkComponent, PhoneHrefPipe, PhoneMaskPipe, RouterLink],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  cmsService = inject(CmsService);
  featureFlagService = inject(FeatureFlagService);
  contactService = inject(ContactService);

  FeatureFlagEnum = FeatureFlagEnum;
}
